import NamietkaKuGestorstvuPage from './NamietkaKuGestorstvuPage';

export default NamietkaKuGestorstvuPage;
